import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** Compose conditional Tailwind classes. Used everywhere instead of template strings. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
